import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
// import { UtilityService } from 'src/app/services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { UtilityService } from 'src/app/shared/utils/utility.service';

@Component({
  selector: 'app-doc-response',
  templateUrl: './doc-response.component.html',
  styleUrls: ['./doc-response.component.css']
})
export class DocResponseComponent implements OnInit {
  @Output() responseUrl = new EventEmitter<String>();
  @Input() isSubmitted: boolean = false;
  _url: string = ''
  @Input() set url(url) {
    ;
    if (url) {
      this._url = url;
      this.extension = url.split('.').pop();
      this.filename = url.split('/').pop()
    }
  }
  invalidFileType: boolean = false;
  showProgress: boolean = false;
  showDeleteModal: boolean = false;
  fileUploaded: boolean = false;
  fileList: any = [];
  invalidFileList: any = [];
  extension: string = '';
  filename: string = '';
  progress: number = 0;
  constructor(private utitlityService: UtilityService, private toaster: ToastrService) { }


  onFilesChange(fileList: Array<File>) {
      
    this.fileList = fileList;
    
    if (this.fileList.length == 1) {
      const file = this.fileList[0];
      this.filename = file.name
      this.extension = file.name.split('.')[file.name.split('.').length - 1];
      if(!(this.extension == 'txt' || this.extension == 'docx' || this.extension == 'doc' || this.extension == 'pdf' || this.extension == 'ppt' || this.extension == 'pptx')){
       this.filename = "";
       this.toaster.warning("Invalid File Type");
        return false;
      }
      let formData = new FormData();
      formData.append('resources', file);
      this.showProgress = true;
      this.utitlityService.uploadFile(formData).subscribe(url => {
        this.progress = 100;
        this.responseUrl.emit(url);
      });
    }
  }
  filesInvalidEmiter(fileList: Array<File>) {
    this.invalidFileList = fileList;
  }

  ngOnInit() {
  }

  hide() {
    this.showDeleteModal = false;
  }
  delete() {
    this.filename = '';
    this.fileList = [];
    this.responseUrl.emit('');
    this.hide();
  }
  show() {
    this.showDeleteModal = true;
  }

  downloadFile() {
    window.open(this._url, '_blank');
  }
}
